var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import affiliatesHeroSrc from '@images/marketing/Affiliate-NomSquadGoals.jpg';
import startASubscriptionHeroSrc from '@images/marketing/FAQ-Subscription.jpg';
import preferASubscriptionSrc from '@images/marketing/FindInStore-Subscription.jpg';
import trySamplerHeroSrc from '@images/marketing/HIW-SamplerPack.jpg';
import newWaysToNomHeroSrc from '@images/marketing/Home-Map.jpg';
import treatsAndExtrasHeroSrc from '@images/marketing/Home-MoreThanMeals.jpg';
import whyNomNomHeroSrc from '@images/marketing/Home-WhyNomNom.jpg';
import vetFormulatedProbioticsHeroPDPSrc from '@images/marketing/PDPs/Probiotics-FormulatedBy.jpg';
import readySetNomHeroSrc from '@images/marketing/PDPs/SamplerPack-ReadySetNom.jpg';
import buildYourBoxHeroSrc from '@images/marketing/PDPs/Treats-BuildYourBox.jpg';
import vetFormulatedProbioticsHeroPLPSrc from '@images/marketing/PLPs/Probiotics-ExpertlyFormulated.jpg';
import subscribeToGreatHealthHeroSrc from '@images/marketing/PLPs/Probiotics-Subscribe.jpg';
import joinTheNomSquadHeroSrc from '@images/marketing/Team-JointheNomSquad.jpg';
import designedForConvenienceHeroSrc from '@images/marketing/WhyNN-Convenience.jpg';
export var whyNomNomFeaturetteContent = {
    buttonLabel: 'Why Nom Nom',
    headline: 'Dog parents know that it’s essential to keep mealtime exciting',
    subhead: 'That’s why our vet-developed dog food recipes burst with the balanced nutrition pups need and the tastes and textures they crave.',
    heroImage: {
        src: whyNomNomHeroSrc,
        alt: 'Marketing image of Nom Nom treats and probiotics',
    },
    ctaUrl: '/why-nom-nom',
};
export var treatsAndExtrasFeaturetteContent = {
    headline: 'More Than Meals',
    buttonLabel: 'Treats & Extras',
    ctaUrl: '/other-products',
    tickerText: ['treats', 'probiotics'],
    subhead: 'Go the extra mile for your pup with vet-developed probiotics and top-quality treats. They’re a great complement to a diet of gently cooked dog food.',
    heroImage: {
        src: treatsAndExtrasHeroSrc,
        alt: 'Dog eagerly waiting to be fed a Nom Nom meal',
    },
};
export var waysToNomRecipesFeaturetteContent = {
    headline: 'More Ways to Nom',
    subhead: 'Not into a monthly dog food subscription? Fetch our recipes whenever you want them from your favorite retailer.',
    heroImage: {
        src: newWaysToNomHeroSrc,
        alt: 'Fake map of Nom Nom retail locations',
    },
    buttonLabel: 'Find in Store',
    ctaUrl: '/retail',
};
export var waysToNomProbioticsFeaturetteContent = __assign(__assign({}, waysToNomRecipesFeaturetteContent), { isExternalLink: true, buttonLabel: 'Find on Amazon', ctaUrl: 'https://www.amazon.com/stores/NomNom/page/06966E06-7371-4AD9-9948-F2C3B5EE195C' });
export var testFixtureFeaturetteContent = {
    headline: '',
    buttonLabel: '',
    tickerText: '',
    subhead: '',
    heroImage: {
        src: '',
        alt: '',
    },
};
export var designedForConvenienceFeaturetteContent = {
    headline: 'Designed With Convenience in Mind',
    subhead: 'No need to guess about calorie requirements and serving sizes. We’ll figure it out for you, and send pre-portioned meal packs straight to your door.',
    heroImage: {
        src: designedForConvenienceHeroSrc,
        alt: 'An assortment of Nom Nom meals served in colorful bowls',
    },
};
export var samplerPackFeaturetteContent = {
    headline: 'Try our Sampler Pack',
    buttonLabel: 'Try Sampler Pack',
    ctaUrl: '/meals/sampler-pack',
    subhead: 'Want a nibble of Nom Nom? Our Sampler Pack includes a variety of vet-developed, gently cooked recipes at an especially tasty price.',
    heroImage: {
        src: trySamplerHeroSrc,
        alt: 'Promotional Image of a Nom Nom Sampler Pack',
    },
};
export var startASubscriptionFeaturetteContent = {
    headline: 'Start a Subscription',
    subhead: 'Ready to unleash the feast? Treat your pup to nutritious, floor-licking delicious dog food delivered directly to your door.',
    heroImage: {
        src: startASubscriptionHeroSrc,
        alt: 'A dog parent feeding a bowl of Nom Nom to her dog',
        size: {
            width: 498,
        },
        aspectRatio: '498 / 380',
    },
    ctaUrl: '/profile',
    buttonLabel: 'Get Started',
};
export var preferASubscriptionFeaturetteContent = {
    headline: 'Prefer a Subscription?',
    subhead: "There are so many benefits to being a Nom Nom subscriber, including plans personalized to your dog's unique nutritional needs and delivered directly to your door. Try us today!",
    buttonLabel: 'Get Started',
    ctaUrl: '/profile',
    heroImage: {
        src: preferASubscriptionSrc,
        alt: 'A packed shipping container of Nom Nom meals',
    },
};
export var preferASubscriptionPLPFeaturetteContent = {
    headline: 'Prefer a Subscription?',
    subhead: "There are so many benefits to being a Nom Nom subscriber, including plans personalized to your dog's unique nutritional needs and delivered directly to your door. Try us today!",
    buttonLabel: 'Get Started',
    ctaUrl: '/profile',
    heroImage: {
        src: subscribeToGreatHealthHeroSrc,
        alt: 'A packed shipping container of Nom Nom meals',
    },
};
export var buildYourBoxFeaturetteContent = {
    headline: 'Build Your Box',
    subhead: 'Top-quality treats can be added directly to your order as part of a subscription. Start your meal plan today.',
    buttonLabel: 'Get Started',
    ctaUrl: '/profile',
    heroImage: {
        src: buildYourBoxHeroSrc,
        alt: 'A Samoyed puppy tries to snatch a few Nom Nom Beef Blueberry Wafers from the kitchen counter',
    },
};
export var subscribeToGreatHealthFeaturetteContent = {
    headline: 'Subscribe to Great Health',
    subhead: 'Do good by your pup’s gut by nurturing them with vet-developed meals and probiotics today.',
    buttonLabel: 'Get Started',
    ctaUrl: '/profile',
    heroImage: {
        src: subscribeToGreatHealthHeroSrc,
        alt: 'A black dog hungrily licks its lips while awaiting a bowl of Nom Nom dog food',
    },
};
export var vetFormulatedProbioticsFeaturetteContentPLP = {
    headline: 'Expertly Formulated by a Veterinary Nutritionist',
    subhead: "\u201CProbiotics are a great way to support your dog\u2019s overall health.\u201D<br/><br/>\u2014 Dr. Sally Perea, DVM, MS, DACVIM",
    heroImage: {
        src: vetFormulatedProbioticsHeroPLPSrc,
        alt: 'A dog waits to be fed a bowl of Nom Nom dog food before a background of competition trophies',
    },
};
export var vetFormulatedProbioticsFeaturetteContentPDP = {
    headline: 'Formulated By a Veterinary Nutritionist & Microbiologist',
    subhead: "\u201CProbiotics are a great way to support your dog\u2019s overall health.\u201D<br/><br/>\u2014 Dr. Sally Perea, DVM, MS, DACVIM",
    heroImage: {
        src: vetFormulatedProbioticsHeroPDPSrc,
        alt: 'A dog with a ball in its mouth plays in the yard',
    },
};
export var readySetNomFeaturetteContent = {
    headline: 'Ready, Set, Nom',
    subhead: '<p>Store dog food in the freezer until ready to use, then thaw in the fridge overnight. Once defrosted, food can be kept in the fridge for up to 5 days.</p><br><p>Serve as complete and balanced meals, use as healthy and tasty toppers, or even offer as enrichment — try hiding a spoonful in puzzles or dabbing on lick mats.</p> ',
    ctaUrl: 'https://www.nomnomnow.com/learn/article/determining-dog-food-portion-size',
    buttonLabel: 'Learn More',
    heroImage: {
        src: readySetNomHeroSrc,
        alt: 'A dog licks its lips between bites of NomNom dog food',
    },
};
export var joinTheNomSquadFeaturetteContent = {
    headline: 'Join the Nom Squad',
    subhead: 'We’re always sniffing out great talent. Coders, marketers, operations specialists, P&O folks, if you’re here for dogs — and dog parents — we’re here for you.',
    heroImage: {
        src: joinTheNomSquadHeroSrc,
        alt: 'A dog gives a high five to its owner',
    },
    ctaUrl: '/careers',
    buttonLabel: 'Careers',
};
export var affiliateFeaturetteSectionContent = {
    headline: '#Nomsquadgoals',
    subhead: '<p>Dog parents like you just GET other dog parents. Poop bags in every pocket? Sleeping on the edge of the bed? Check.</p><br/><p>That’s how we know you’ll create the world’s most exciting content about the world’s most exciting dog food.</p>',
    heroImage: {
        src: affiliatesHeroSrc,
        alt: 'A man hugs his dog against a background of green foliage',
    },
    ctaUrl: 'https://buy.nomnomnow.com/affiliate/',
    buttonLabel: 'Sign Up',
    isExternalLink: true,
};
